import { render, staticRenderFns } from "./BoardEdit.vue?vue&type=template&id=68946686"
import script from "./BoardEdit.vue?vue&type=script&lang=js"
export * from "./BoardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports